define('ShopByModel.Model',
  [
    'SCModel',
    'Utils'
  ],
  function
  (
    SCModelModule,
    Utils
  ) {
    'use strict';

    var SCModel = SCModelModule.SCModel;

    function ShopByModelModel(model, options) {
      SCModel.call(this, model, options);

      this.urlRoot = function urlRoot() {
        return Utils.getAbsoluteUrl(getExtensionAssetsPath('services/ShopByModel.Service.ss'));
      };
    }

    ShopByModelModel.prototype = Object.create(SCModel.prototype);
    ShopByModelModel.prototype.constructor = ShopByModelModel;

    return ShopByModelModel;
  });
